// extracted by mini-css-extract-plugin
export default {"comments":"CommentList_comments__VqVBF","commentsTitle":"CommentList_commentsTitle__Hvb0l","failComment":"CommentList_failComment__alhw5"};